/**
 * Shared rating scale functions used by both V1 and V2 offline rating calculators.
 *
 * Standard scale: maps a percentage score (0–100) to a 1–5 rating.
 * No-predefined scales: used by V2 for categories without predefined observations.
 */

/** Standard rating scale — used by Rating A, Rating B, and breakdown calculations. */
export const ratingScale = (score: number): number => {
	// How-Often completion can exceed 100% when observed attempts outnumber
	// expected/predefined attempts; clamp so best performance maps to 5, not the
	// fallthrough of 1. NaN passes through unchanged (empty categories stay 1).
	score = Math.min(score, 100);
	if (score <= 60) return 1;
	if (score <= 70) return 2;
	if (score <= 80) return 3;
	if (score <= 90) return 4;
	if (score <= 100) return 5;
	return 1;
};

/** No-predefined scale (V2) — shared by Rating A and Rating B. */
export const noPredefinedRatingScale = (percentage: number): number => {
	if (percentage >= 65) return 3;
	if (percentage >= 35) return 2;
	return 1;
};
